import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'upmarket-multi_user_education_banner_profile_picture_upload-submit';
/**
 * Event that gets triggered when the user uploads a new profile picture using the multi user homepage team education banner.
 */
export function trackUpmarketMultiUserEducationBannerProfilePictureUploadSubmit() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
